"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const Phone = _ref => {
  let {
    title = 'Phone',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.813 17.031q3 5.813 8.813 8.813l2.938-2.938q0.625-0.625 1.375-0.313 2.25 0.75 4.75 0.75 0.563 0 0.938 0.375t0.375 0.938v4.688q0 0.563-0.375 0.938t-0.938 0.375q-9.375 0-16.031-6.656t-6.656-16.031q0-0.563 0.375-0.938t0.938-0.375h4.688q0.563 0 0.938 0.375t0.375 0.938q0 2.5 0.75 4.75 0.25 0.813-0.313 1.375z"
  }));
};
var _default = exports.default = (0, _ikon.default)(Phone);
Phone.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Phone",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Phone'",
        "computed": false
      },
      "required": false
    }
  }
};